/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "ablmsApi",
            "endpoint": "https://69k9v7bknb.execute-api.us-east-2.amazonaws.com/production",
            "region": "us-east-2"
        }
    ],
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_bQoG2ZFUN",
    "aws_user_pools_web_client_id": "53es11avsi3ra1a8qiqjadd7uf",
    "oauth": {
        "domain": "abl-ms.auth.us-east-2.amazoncognito.com",
        "scope": [
            "aws.cognito.signin.user.admin",
            "email",
            "openid",
            "phone",
            "profile"
        ],
        "redirectSignIn": "http://localhost:3000,http://localhost:443/cylon/test,http://localhost:8080,https://abl-ms.auth.us-east-1.amazoncognito.com/login,https://cylon-old.webbank.com,https://cylon.webbank.com,https://dev.cylon2.webbank.com,https://qa.cylon2.webbank.com,https://test.cylon.webbank.com",
        "redirectSignOut": "http://localhost:3000/login,http://localhost:443,http://localhost:8080/login,https://cylon-old.webbank.com/login,https://cylon.webbank.com/login,https://dev.api.webbank.com/cylon,https://dev.cylon2.webbank.com/login,https://test.cylon.webbank.com/login",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
